export const getLauncherTables = (tables = []) => tables
  .filter((table) => table?.id && table.active !== false)
  .slice().sort((a, b) => Number(a.tableNumber || 0) - Number(b.tableNumber || 0));

export const createTabletOrderSession = (table) => {
  if (!table?.id || table.active === false || !table.qr?.token) {
    throw new Error("Esta mesa no tiene un QR activo para abrir la carta.");
  }
  const browserCrypto = typeof window !== "undefined" ? window.crypto : null;
  const id = browserCrypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return { table, key: `tablet:${table.branchId}:${table.id}:${id}` };
};

// Only this launcher's temporary guest data is removed, never an ordinary QR session.
export const clearTabletOrderSession = (key) => {
  if (!key?.startsWith("tablet:") || typeof window === "undefined") return;
  for (const name of ["sessionStorage", "localStorage"]) {
    try {
      const storage = window[name];
      for (const prefix of ["mozzoapp:qr-cart:", "mozzoapp:qr-submitted-order:", "mozzoapp:qr-customer:", "mozzoapp:qr-access:", "mozzoapp:kiosk-language:"]) {
        storage.removeItem(`${prefix}${key}`);
      }
    } catch { /* Storage can be unavailable in private browsing. */ }
  }
};
